import { motion, useReducedMotion } from 'motion/react';
import { panelMotion } from './motion';

export default function Panel({ children, title, action, className = '' }) {
  const reduceMotion = useReducedMotion();
  const motionProps = reduceMotion ? {} : panelMotion;

  return (
    <motion.div className={['aui-panel', className].filter(Boolean).join(' ')} {...motionProps}>
      {(title || action) && (
        <div className="aui-panel-head">
          {title && <h3>{title}</h3>}
          {action && <div>{action}</div>}
        </div>
      )}
      {children}
    </motion.div>
  );
}
